import { SDK_PROD_CONFIG } from "./app.config";
import { SDK_DEV_CONFIG } from "./app.dev.config";
import { SDK_TEST_CONFIG } from "./app.test.config";

const configMapper: Record<string, typeof SDK_PROD_CONFIG> = {
  test: SDK_TEST_CONFIG,
  development: SDK_DEV_CONFIG,
  production: SDK_PROD_CONFIG,
  staging: SDK_PROD_CONFIG,
};

export const getSdkConfigByEnv = (nodeEnv: string | undefined) => {
  const envKey = nodeEnv || "production";
  return configMapper[envKey] || SDK_PROD_CONFIG;
};
